import { RecipeFormValues } from './../models/form-values';
import { Action } from '@ngrx/store';
import { AdditionalService } from '@cemex-core/cmx-api';
import { RetailFormConfig } from '../models/retail-form-config';

export enum RetailSpecificationActionTypes {
  INIT = '[Retail Specification] Init',
  RESET = '[Retail Specification] Reset',
  ADD_ITEM = '[Retail Specification] Add recipe item',
  UPDATE_ITEM = '[Retail Specification] Update recipe item',
  SET_ITEMS_SEQ_NUM = '[Retail Specification] Set items seq num',
  RESET_ITEMS_SEQ_NUM = '[Retail Specification] Reset items seq num',
  SET_ADDITIONAL_SERVICES = '[Retail Specification] Set additional services',
  SET_INVOICE_LOADED = '[Retail Specification] Set invoice loaded',
  REMOVE_ITEM = '[Retail Specification] Remove recipe item',
  SET_NEW_ORDER_CREATION = '[Retail Specification] set new order creation',
}

export class RetailSpecificationLoadAction implements Action {
  readonly type = RetailSpecificationActionTypes.INIT;

  constructor(public payload: RetailFormConfig) {}
}

export class RetailSpecificationAddItemAction implements Action {
  readonly type = RetailSpecificationActionTypes.ADD_ITEM;

  constructor(public payload?: { [key: string]: any }) {}
}

export class RetailSpecificationUpdateItemAction implements Action {
  readonly type = RetailSpecificationActionTypes.UPDATE_ITEM;

  constructor(public payload: RecipeFormValues) {}
}

export class RetailSpecificationSetItemsSeqAction implements Action {
  readonly type = RetailSpecificationActionTypes.SET_ITEMS_SEQ_NUM;

  constructor() {}
}

export class RetailSpecificationResetItemsSeqAction implements Action {
  readonly type = RetailSpecificationActionTypes.RESET_ITEMS_SEQ_NUM;

  constructor() {}
}

export class RetailSpecificationSetAdditionalServicesAction implements Action {
  readonly type = RetailSpecificationActionTypes.SET_ADDITIONAL_SERVICES;

  constructor(public payload: { services: AdditionalService[]; itemSeqNum: number }) {}
}

export class RetailSpecificationRemoveItemAction implements Action {
  readonly type = RetailSpecificationActionTypes.REMOVE_ITEM;

  constructor(public payload: number) {}
}

export class RetailSpecificationSetInvoiceLoadedAction implements Action {
  readonly type = RetailSpecificationActionTypes.SET_INVOICE_LOADED;

  constructor(public payload: boolean) {}
}

export class RetailSpecificationSetNewOrderCreationAction implements Action {
  readonly type = RetailSpecificationActionTypes.SET_NEW_ORDER_CREATION;

  constructor(public payload: boolean) {}
}

export class RetailSpecificationResetAction implements Action {
  readonly type = RetailSpecificationActionTypes.RESET;

  constructor() {}
}

export type RetailSpecificationActions =
  | RetailSpecificationLoadAction
  | RetailSpecificationResetAction
  | RetailSpecificationAddItemAction
  | RetailSpecificationUpdateItemAction
  | RetailSpecificationSetItemsSeqAction
  | RetailSpecificationResetItemsSeqAction
  | RetailSpecificationSetAdditionalServicesAction
  | RetailSpecificationSetInvoiceLoadedAction
  | RetailSpecificationSetNewOrderCreationAction
  | RetailSpecificationRemoveItemAction;
